import { ApiResponse, GlobalStore, GridStore } from '@roc/feature-app-core';
import { makeObservable } from 'mobx';
import { SpecialServicingService } from 'libs/feature-special-servicing/src/specialServicing/services/specialServicingService';
import { SpecialServicingBaseStore } from '@roc/feature-special-servicing';

export class InvoicesDashboardStore extends SpecialServicingBaseStore{
  gridStore: GridStore;

  constructor(globalStore: GlobalStore) {
    super(globalStore);
    this.globalStore = globalStore;
    this.service = new SpecialServicingService();
    makeObservable(this, {});
  }

  reset() {
    this.counterPartyExpenseGridStore.reset();
  };

  performAction(id: number, status: string) {
    throw Error('Not Implemented!');
  }
  performActions(status: string) {
    throw Error('Not Implemented!');
  }
  fetchEntityNames() {
    throw new Error('Method not implemented.');
  }
}
